/** French unit-rate vocabulary and template (ADR 0051 part 3). */
export const ratePairs: Array<{ of: string; per: string; perPlural: string }> = [
    { of: 'miles', per: 'heure', perPlural: 'heures' },
    { of: 'mots', per: 'minute', perPlural: 'minutes' },
    { of: 'dollars', per: 'article', perPlural: 'articles' },
    { of: 'pages', per: 'jour', perPlural: 'jours' },
    { of: 'litres', per: 'minute', perPlural: 'minutes' },
    { of: 'points', per: 'partie', perPlural: 'parties' },
];

export const ratioPrompts = {
    unitRate: (total: number, of: string, units: number, perPlural: string, per: string) =>
        `${total} ${of} en ${units} ${perPlural} = ______ ${of} par ${per}`,
    /** ADR 0104 §2: the three table questions and the two answers of the first. */
    proportionalYesNo: () =>
        `y est-il proportionnel à x ? Si oui, donne la constante de proportionnalité.`,
    proportionalConstant: () =>
        `Trouve la constante de proportionnalité, puis écris une équation pour y.`,
    proportionalFill: () => `y est proportionnel à x. Complète le tableau.`,
    proportionalYes: (constant: number) => `Oui, k = ${constant}`,
    proportionalNo: () => `Non`,
    /** ADR 0105 §2: the graph question that reads past the edge of the grid. */
    proportionalBeyond: (x: number) => `Utilise le graphique pour trouver y quand x = ${x}.`,
};
